const SEO = [
	{
		page: "home",
		description:
			"I am a Full stack Web Developer with a years experience working on React, NodeJS, Mysql PERL and Splunk. I have a masters degree in computer science and i like to build scalable and reliable web applications.",
		keywords: ["Vrushab Hanumesh"],
	},

	{
		page: "about",
		description:
			"I am a Full stack Web Developer with a years experience working on React, NodeJS, Mysql PERL and Splunk. I have a masters degree in computer science and i like to build scalable and reliable web applications.",
		keywords: ["Vrushab Hanumesh"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Vrushab Hanumesh"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Vrushab Hanumesh"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Vrushab Hanumesh"],
	},
];

export default SEO;
